import React from 'react';

import { Inline, Text } from '@atlaskit/primitives/compiled';

export const LikeCount = ({ numberOfLikes }: { numberOfLikes: number }): React.JSX.Element => {
	return (
		<Inline space="space.050">
			<Text as="span" size="small">
				👍
			</Text>
			<Text size="small">{numberOfLikes}</Text>
		</Inline>
	);
};
